import { useDispatch} from "react-redux";
import { bindActionCreators } from "redux";
import { actions as asyncActions} from "async-ops";
import MdaePopup, {
    MdaePopupTitle,
    MdaePopupContent,
    MdaePopupFooter,
    MdaePopupFooterEndButtons,
  } from "../../common_components/common_widgets/popup";
import MdaeButton from "../../common_components/common_widgets/button";
import React from "react";
import { TOGGLE_EDIT_REQUESTER_ALERT_POPUP } from "./reducers/audit-properties-reducer";

interface IEditRequesterPermissionAlertPopup {
  toggleEditRequesterPermissionAlertPopupVisible: (
      isVisible: boolean,
      mode?: string,
      height?: number | string,
    ) => void;
  }

const EditRequesterPermissionAlertPopup: React.FC<IEditRequesterPermissionAlertPopup> = (
    props
  ) => {

    const getPopupTitle = () => {
        return (
          <MdaePopupTitle
            isSmallPopup
            closePopupHandler={() => {
              props.toggleEditRequesterPermissionAlertPopupVisible(false);
            }}
          >
           Alert
          </MdaePopupTitle>
        );
      };

    return (
        <MdaePopup
          deferRendering={false}
          height={210}
          width={400}
          className="edit-requester-alert-popup"
          mdaeTitleRender={getPopupTitle}
          mdaeDataUpdaterConfig={[
            {
              actionType: TOGGLE_EDIT_REQUESTER_ALERT_POPUP,
              reducerName: "auditPropertiesReducer",
              widgetOptionBindings: {
                visible: "isEditRequesterAlertPopupVisible",
              },
            },
          ]}
          mdaeContentRender={() => {
            return (
              <div>
                <MdaePopupContent>
                    <div>
                    You do not have permission to make these changes, please contact a user with Feature Group: Payer Audit Maintenance.
                    </div>
                </MdaePopupContent>
              </div>
            );
          }}
          mdaeFooterRender={() => {
            return (
                <MdaePopupFooter>
                <MdaePopupFooterEndButtons>
                  <MdaeButton
                    id={"pnlCategoryTerminationWarningPrimaryBtn"}
                    role={"primary"}
                    onClick={() => {
                      props.toggleEditRequesterPermissionAlertPopupVisible(false);
                    }}
                  >
                    Close
                  </MdaeButton>
                </MdaePopupFooterEndButtons>
              </MdaePopupFooter>
            );
          }}
        ></MdaePopup>
      );
}

export default EditRequesterPermissionAlertPopup